import type { AttemptData, ChallengeData } from "shared/schema";
import { MenuButton } from "shared/react";
import { getMarkupExcerpt } from "shared/schema";
import { RewardBackgroundCard } from "../entity/EntityBackgroundCard.js";
import { EntityButton } from "../entity/EntityButton.js";
import { useOptionalGroupContext } from "../group/GroupContext.js";
import { LeaderboardButton } from "../leaderboard/LeaderboardButton.js";
import { ChallengeLeaderboardList } from "../leaderboard/LeaderboardList.js";
import { RewardIcon } from "../reward/RewardIcon.js";
import { useAttemptItem } from "../util/data.js";
import { useItem } from "../util/db.js";
import { ChallengeMenu } from "./ChallengeMenu.js";
import { ChallengeButtons, ChallengeStatus, ChallengeTasks } from "./ChallengeTasks.js";
import { Tasks } from "./Tasks.js";

export function RawChallengeCard({ id, challenge, attempt }: { id?: string; challenge: ChallengeData; attempt?: AttemptData | undefined }): React.ReactElement {
	const { name, about, badge, background, creator, tasks } = challenge;
	const path = id ? `/challenge/${id}` : undefined;
	const excerpt = getMarkupExcerpt(about);
	const group = useOptionalGroupContext();
	return (
		<RewardBackgroundCard id={background} mods="targeted pad-none">
			<header className="flex-row flex-middle space-none pad-xxsmall gap-xxsmall">
				<RewardIcon id={badge} mods="size-2x color-quiet" type="badge" />
				<div className="text-left flex-full">
					<h3 className="space-none text-ellipsis">
						<a className="target" href={path}>
							{name}
						</a>
					</h3>
					{excerpt ? <p className="space-none size-small">{excerpt}</p> : null}
				</div>
			</header>
			{id ? <MenuButton menu={<ChallengeMenu id={id} />} mods="button-quiet pin-top pin-right" /> : null}
			<section className="panel space-none pad-xsmall">{id ? <ChallengeTasks id={id} challenge={challenge} attempt={attempt} /> : <Tasks tasks={tasks} />}</section>
			<footer className="panel space-none pad-none flex-row gap-xsmall size-small">
				<EntityButton entity={creator} />
				<ChallengeStatus challenge={challenge} attempt={attempt} mods="flex-full" />
			</footer>
			{!id ? null : group ? (
				<LeaderboardButton creator={`group:${group.id}`} cid={id} mods="space-none size-small" /> //
			) : (
				<ChallengeLeaderboardList cid={id} empty={null} mods="space-none flex-column gap-none size-small" />
			)}
			{id ? <ChallengeButtons id={id} challenge={challenge} attempt={attempt} mods="space-none" /> : null}
		</RewardBackgroundCard>
	);
}

export function ChallengeCard({ id }: { id: string }): React.ReactElement {
	const challenge = useItem("challenge", id);
	const attempt = useAttemptItem(id);
	return <RawChallengeCard id={id} challenge={challenge.data} attempt={attempt.value} />;
}
